import {IOrderLineDto} from "../../../Apis/Models/IOrderDto";

export function getOrderLineUnitSalesPrice(orderLine: IOrderLineDto) {
    return (orderLine.product.productType === 'Discount' ? -orderLine.discountAsAmount : orderLine.unitSalesPriceInclDiscount) ?? 0;
}

export function getOrderLineTotal(orderLine: IOrderLineDto) {
    return orderLine.quantity * (getOrderLineUnitSalesPrice(orderLine));
}

export function getOrderLineUnitCost(orderLine: IOrderLineDto) {
    return (orderLine.unitCostPrice ?? 0);
}

export function getOrderLineTotalCost(orderLine: IOrderLineDto) {
    return orderLine.quantity * getOrderLineUnitCost(orderLine);
}

export function getOrderLinesTotalCost(orderLines: IOrderLineDto[]) {
    return orderLines.reduce((a, b) => a + (getOrderLineTotalCost(b)), 0)
}

export function getOrderLinesTotal(orderLines: IOrderLineDto[]) {
    return orderLines.reduce((a, b) => a + (getOrderLineTotal(b)), 0)
}

export function getOrderLinesTotalInclVat(orderLines: IOrderLineDto[]) {
    return getOrderLinesTotal(orderLines) + getOrderLinesTotalVat(orderLines);
}

export function getOrderLinesTotalVat(orderLines: IOrderLineDto[]) {
    return orderLines.reduce((a, b) => a + (b.quantity * (getOrderLineUnitSalesPrice(b) ?? 0) * 0.25), 0)
}

export function getOrderLinesProductionCount(orderLines: IOrderLineDto[]) {
    return orderLines
        .filter(x => x.product.productType === 'Product')
        .reduce((a, b) => a + b.quantity, 0)
}
